<template>
  <div class="wrap">
    <v-container fluid>
      <v-row class="text-center" align-v="center">
        <v-col cols="12" md="5" class="animated fadeIn" style="background-color: #ffffff; border-radius: 20px 0px 0px 20px;" >
          <div class="login_wrapper flex center v_center">
            <h1 class="app-title">
              <a href="" class="logo animated fadeIn"></a>
              <br>
              Payment<span class="color">Office</span>
            </h1>
          </div>
        </v-col>
        <v-col cols="12" md="7" class="col-7">
          <div class="login_wrapper flex center v_center">
            <div class="wrap_for_form">
              <form ref="login_form" action class="flex column login_form">
                <a class="g-signin-button text--secondary" @click="redirectToGoogleSignIn"><v-icon color="primary">mdi-exit-to-app</v-icon> Sign In
                </a>
              </form>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import store from '../../../store';

  export default {
    name: 'Login',
    data() {
      return {
        authUrl: '',
      };
    },
    methods: {
      redirectToGoogleSignIn() {
        window.location.href = this.googleAuthUrl;
      },
    },
    computed: {
      ...mapGetters('user', ['getGoogleAuthUrlStore']),
      ...mapState('user', ['googleAuthUrl']),
    },
    async mounted() {
      await store.dispatch('user/SaveGoogleAuthUrl');
      this.authUrl = this.getGoogleAuthUrlStore;
    },
  };
</script>

<style scoped lang="sass">
  body
    padding: 50px
    .wrap
      background-color: #3A3852
      width: inherit
      height: 100vh
      padding-top: 50px
    .container
      margin-left: auto !important

    .container--fluid
      border-radius: 20px
      margin: auto
      width: 90%
      height: 90vh

      .row
        height: 100%
        .col
          height: 100%
      .col-7
        @media (min-width: 960px)
          background: #F7F8FC
          border-radius: 0px 20px 20px 0px
          height: 100%

      .login_wrapper
        width: 100%
        height: 100%

        .color
          color: #36B8E1

        .wrap_for_form
          .logo
            display: block
            width: 168px
            height: 55px
            margin: 0 auto 20px
            background-size: cover
            background: url('../../../assets/logo.svg')

          form.login_form
            width: 100%
            margin: 0 auto
            padding: 40px
            color: #7F98A5
            background: rgba(255, 255, 255, 0.05)
            border-radius: 20px

            h2
              font-weight: 400
              color: #3A3852
              font-size: 18px
              text-transform: uppercase
              text-align: center
              letter-spacing: 2px
              margin-bottom: 40px

            input
              margin-top: 0px
              margin-bottom: 30px
              font-size: 14px
              letter-spacing: 0.5px
              outline: 0
              color: #7F98A5
              font-weight: 500
              background: #fff
              border: 2px solid #f4f4f4

              &::placeholder
                color: #ACC3CF
                font-size: 14px
                letter-spacing: 0.5px

              &.user_email,
              &.password
                width: 100%
                padding: 15px 25px
                border-radius: 7px

              &.error_input
                border: 2px solid #FE5D65

            .error
              display: none
              font-size: 0.9rem
              font-weight: 500
              margin-bottom: 1rem
              margin-top: 0px
              letter-spacing: 0.5px
              color: #fff
              background: #fe5d65
              padding: 10px
              border-radius: 4px

              &.error_email
                display: block

              &.error_password
                display: block

            .rememberme
              margin: 20px 0 0 -10px

              label
                color: rgba(255, 255, 255, 0.5)
                cursor: pointer
                font-size: 12px
                font-weight: 500

                input
                  visibility: hidden

                  &:checked + i
                    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAExSURBVHgB7ZU9TsMwGIbf71MFKxdAJTcAqUWMzQJi5AZwAzhBcgO4AeUEbERiAVZgyA0SbpANqQh/2JYi0ipu7P5NfZfIP3oe24o/A9t0hJqNYVZcgvmWBHtYLKUmpu9n/Ye6g6dsxMkScJMDUbhrdvDsBCwZoukFMtacVQhKYR6Z7zoE5URU/HG6/8airlYtsPD8PCqHz8XhL/NjkEAIFTzgJ1kxgvCL6+9rFQho/KPUEdrP9X/l+t4ocsOdAiJ5NQADmpHkTbi+N/foSPsRCcaDp+LaSnb1Tgi5hX+Hwd0CM6BLxiD7SvM4qiY7Krbwi6g61n2+cJPevEEmJFqCz7ifmraB690kCEiva0ItsVsNhHsJagkWzGZrUcfl8k3pFECpGziKlk/sAvWDg21C8gesNoO20KGVbgAAAABJRU5ErkJggg==') no-repeat center center

                i
                  display: block
                  width: 18px
                  height: 18px
                  border: 2px solid #36B8E1
                  border-radius: 2px
                  margin-right: 10px

              a
                cursor: pointer
                font-size: 12px
                font-weight: 500
                text-decoration: none
                color: #36B8E1
                transition: all 0.3s ease

                &:hover
                  color: #67E6F5

            a.sign_me_in
              display: block
              text-align: center
              background: linear-gradient(90deg, #555555 0%, #333333 100%)
              background-size: 100%
              text-transform: uppercase
              font-weight: 600
              letter-spacing: 2px
              width: 100%
              max-width: 300px
              padding: 10px
              margin: 0 auto
              color: #FFF
              font-size: 16px
              cursor: pointer
              border-radius: 7px
              border: 0
              transition: all 0.5s ease

              &:hover
                background-size: 150%
                transform: scale(1.05)

              &:hover
                background-size: 150%
                transform: scale(1.05)

            div
              p
                text-align: center
                margin-top: 25px
                font-size: 11px
                letter-spacing: 0.5px
                opacity: 0.87
                color: #7F98A5

                a
                  cursor: pointer
                  text-decoration: none
                  color: #36B8E1
                  font-size: 11px

          h3
            font-weight: 300
            font-size: 14px
            color: #36B8E1
            padding-top: 40px
            text-align: center

      .g-signin-button
        display: inline-block
        padding: 15px
        border-radius: 7px
        background-color: #fff
        color: #3A3852
        font-size: 14px
        font-weight: 600
        letter-spacing: 0.3px
        border: 2px solid #f4f4f4
        text-align: center
        width: 300px
        margin: auto
        transition: all 0.5s ease
        text-decoration: none

        &:hover
          color: #3A3852
          background-color: #fff
          cursor: pointer
          border: 2px solid #3A3852

        img
          width: 14px
          margin-left: -5px
          margin-right: 10px

      .fa-user-circle
        color: #ffffff
        background: linear-gradient(to right, #28cde1 0%, #5883e2 100%)
        -webkit-background-clip: text
        -webkit-text-fill-color: transparent

      .logo
        display: block
        width: 76px
        height: 61px
        margin: 0px auto -10px
        background-size: cover
        background: url('../../../assets/logo-login.svg')

</style>
